import dayjs from 'dayjs';
import { useState } from 'react';
import { Button, Col, Container, Row } from 'react-bootstrap';

const Calendar = ({ onDateClick }) => {
  const today = dayjs();
  const [currentMonth, setCurrentMonth] = useState(today.startOf('month'));
  const [inputValue, setInputValue] = useState(currentMonth.format('MM — MMMM / YYYY'));
  const [selectedDate, setSelectedDate] = useState(null);

  const getCalendarDays = () => {
    const startDay = currentMonth.startOf('week');
    const endDay = currentMonth.endOf('month').endOf('week');
    const days = [];
    let date = startDay;
    while (date.isBefore(endDay, 'day') || date.isSame(endDay, 'day')) {
      days.push(date);
      date = date.add(1, 'day');
    }
    return days;
  };

  const calendarDays = getCalendarDays();

  const handlePrevMonth = () => {
    const newMonth = currentMonth.subtract(1, 'month');
    setCurrentMonth(newMonth);
    setInputValue(newMonth.format('MM — MMMM / YYYY'));
    setSelectedDate(null);
  };

  const handleNextMonth = () => {
    const newMonth = currentMonth.add(1, 'month');
    setCurrentMonth(newMonth);
    setInputValue(newMonth.format('MM — MMMM / YYYY'));
    setSelectedDate(null);
  };

  const handleInputChange = (e) => setInputValue(e.target.value);

  const handleInputBlur = () => {
    const parsed = dayjs(inputValue, ['MM — MMMM / YYYY', 'MMMM YYYY', 'MM/YYYY'], true);
    if (parsed.isValid()) {
      const startOfMonth = parsed.startOf('month');
      setCurrentMonth(startOfMonth);
      setInputValue(startOfMonth.format('MM — MMMM / YYYY'));
      setSelectedDate(null);
    } else {
      setInputValue(currentMonth.format('MM — MMMM / YYYY'));
    }
  };

  const handleDateClick = (day) => {
    const formatted = day.format('YYYY-MM-DD');
    setSelectedDate(day);
    if (onDateClick) onDateClick(formatted);
  };


  return (
    <Container fluid className="p-0">
      <h1
        style={{
          margin: 0,
          padding: 0,
          fontSize: '20px',
          width: '100%',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          display: 'block',
          transform: 'scaleX(1.2)', // less horizontal stretch
          transformOrigin: 'left',   // stretch from left side
          fontSize: '30px',
          fontWeight: '700',
          fontStyle: 'bolder',
          color: '#740A03',
          fontFamily: 'Arial, sans-serif',          // white font

        }}
      >
        CALENDAR
      </h1>


      <div
        className="p-3 rounded"
        style={{
          minHeight: '100%',
         // background: 'linear-gradient(145deg, #e93701ff, rgba(248, 179, 29, 0.89))',  // golden gradient for depth
         // 3D mounted effect
          fontSize: '20px',
          fontWeight: '700',
          fontStyle: 'bolder',
          color: '#740A03',
          fontFamily: 'Arial, sans-serif',  // soft corners
          marginTop: '0px',       // remove extra space above container
        }}
      >
        <div style={{ marginBottom: '4px',
         //   color: '#ffffff', 
           fontWeight: 'bold', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          {/* Day + Month/Year */}
          <div>
            <span
              style={{
                fontSize: selectedDate ? '24px' : '24px', // bigger for today
                letterSpacing: '1px',
                transform: 'scaleX(1.3)',
                transformOrigin: 'left',
                display: 'inline-block',
                marginRight: '12px',
              }}
            >
              {selectedDate
                ? selectedDate.date().toString().padStart(2, '0')
                : today.date().toString().padStart(2, '0')}
            </span>
            <span
              style={{
                fontSize: '15px',
                textTransform: 'uppercase',
                letterSpacing: '1px',
                verticalAlign: 'middle',
              }}
            >
              {selectedDate
                ? selectedDate.format('MMMM / YYYY')
                : currentMonth.format('MMMM / YYYY')}
            </span>
          </div>

          {/* Navigation buttons */}
          <div>
            <Button size="sm" variant="outline-dark" onClick={handlePrevMonth} className="me-2">
              ‹
            </Button>
            <Button size="sm" variant="outline-dark" onClick={handleNextMonth}>
              ›
            </Button>
          </div>
        </div>



        {/* Week Days Header */}
        <Row className="text-center fw-bold text-uppercase small mb-2" style={{ color: '#rgb(116, 10, 3)' }}>
          {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map((d) => (
            <Col key={d} className="text">{d}</Col>
          ))}
        </Row>

        {/* Days Grid */}
        {Array.from({ length: Math.ceil(calendarDays.length / 7) }, (_, weekIdx) => (
          <Row key={weekIdx} className="text-center mb-1">
            {calendarDays.slice(weekIdx * 7, weekIdx * 7 + 7).map((day) => {
              const isToday = day.isSame(today, 'day');
              const isSelected = selectedDate ? day.isSame(selectedDate, 'day') : false;

              return (
                <Col
  key={day.format('YYYY-MM-DD')}
  className={`py-2 rounded`}
  style={{
    backgroundColor: isSelected ? "#f1dbd0" : "#FFFAF0",
    color: "rgb(116, 10, 3)",
    fontWeight: !selectedDate && isToday ? "bolder" : "normal",
    border: !selectedDate && isToday ? "1px solid #ffffff" : "none",
    cursor: "pointer"
  }}
  onClick={() => handleDateClick(day)}
>
                  {day.format('D')}
                </Col>
              );
            })}
          </Row>
        ))}
      </div>
    </Container>
  );
};

export default Calendar;
